import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", y = 28 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "112%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function Marquee({ items }) {
  const row = [...items, ...items, ...items];
  return (
    <div className="overflow-hidden border-y border-white/10 bg-anthracite-dark py-5" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center font-mono-tech text-sm uppercase tracking-[0.3em] text-slate-500">
                <span className="px-8">{item}</span>
                <span className="text-royal-soft">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export function SectionHead({ kicker, title, light = false, testid }) {
  return (
    <Reveal>
      <p className="font-mono-tech text-xs uppercase tracking-[0.35em] text-royal-soft" data-testid={testid ? `${testid}-kicker` : undefined}>{kicker}</p>
      <h2 className={`mt-4 max-w-3xl text-2xl font-black uppercase leading-tight tracking-tight sm:text-3xl lg:text-4xl ${light ? "text-white" : "text-slate-900"}`} data-testid={testid ? `${testid}-title` : undefined}>
        {title}
      </h2>
    </Reveal>
  );
}
